<template>
	<div>
		<ChooseFunding
			v-model="internalFinancesData"
			:input="internalPrioritiesData"
			:countries-changed.sync="internalCountriesChanged"
			:contest-id="contestId"
			:readonly="readonly"
			ref="funding"
		></ChooseFunding>

		<ChooseDAC
      v-if="dacCodesEnabled"
			v-model="internalDacCodes"
			:contest-id="contestId"
			:readonly="readonly"
			type="PUBLIC_CONTEST"
			ref="chooseDac"
		></ChooseDAC>
	</div>
</template>

<script>
import ChooseFunding from "@/view/logged/offer/components/ChooseFunding";
import ChooseDAC from "@/view/logged/offer/components/ChooseDAC";

export default {
  name: "ContestOfferStats",

  components: {ChooseDAC, ChooseFunding},

  data() {
    return {
      internalFinancesData: {},
      internalPrioritiesData: {},
      internalDacCodes: [],
      internalCountriesChanged: false,
    };
  },

  methods: {
    validateExistingRef(name) {
      if (this.$refs[name] === undefined) {
        return true;
      }
      if (typeof this.$refs[name]["validate"] !== "function") {
        return true;
      }
      return this.$refs[name].validate();
    },

    validate() {
      let valid = this.validateExistingRef("funding");
      valid &= this.validateExistingRef("chooseDac");
      return valid;
    }
  },

  watch: {
    financesData: {
      immediate: true,
      handler(value) {
        this.internalFinancesData = value;
      }
    },

    internalFinancesData: {
      immediate: true,
      handler(value) {
        this.$emit("update:financesData", value);
      }
    },

    prioritiesData: {
      immediate: true,
      handler(value) {
        this.internalPrioritiesData = value;
      }
    },

    internalPrioritiesData: {
      immediate: true,
      handler(value) {
        this.$emit("update:prioritiesData", value);
      }
    },

    countriesChanged: {
      immediate: true,
      handler(value) {
        this.internalCountriesChanged = value;
      }
    },

    internalCountriesChanged: {
      immediate: true,
      handler(value) {
        this.$emit("update:countriesChanged", value);
      }
    },

    dacCodes: {
      immediate: true,
      handler(value) {
        this.internalDacCodes = value;
      }
    },

    internalDacCodes: {
      immediate: true,
      handler(value) {
        this.$emit("update:dacCodes", value);
      }
    },
  },

  props: {
    readonly: {type: Boolean, required: true},
    contestId: {required: true},
    financesData: {type: Object, required: true},
    prioritiesData: {type: Object, required: true},
    dacCodesEnabled: {type: Boolean, default: true},
    dacCodes: {type: Array, required: true},
    countriesChanged: {type: Boolean, required: true},
  }
};
</script>

<style scoped>

</style>